import { render, staticRenderFns } from "./CouponDiscountType.vue?vue&type=template&id=63453d21&scoped=true"
import script from "./CouponDiscountType.vue?vue&type=script&lang=js"
export * from "./CouponDiscountType.vue?vue&type=script&lang=js"
import style0 from "./CouponDiscountType.vue?vue&type=style&index=0&id=63453d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63453d21",
  null
  
)

export default component.exports